import type { SizeFitGuide } from 'types/capi/shared';

import SizeGuideIcon from '~/assets/icons/SizeGuide';

type Props = {
  sizeFitGuide: SizeFitGuide;
};

const SizeInfo = ({ sizeFitGuide }: Props) => {
  if (!sizeFitGuide) return null;

  return <Description adjustment={sizeFitGuide.adjustment.toString()} />;
};

const Description = ({ adjustment }: { adjustment: string }) => {
  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-1">
      <div className="flex items-center justify-center gap-2 text-sm tracking-wide text-grey-read">
        <SizeGuideIcon stroke="#A9A9A9" height="16" width="16" />
        <SizeGuideText adjustment={adjustment} />
      </div>
    </div>
  );
};

function SizeGuideText({ adjustment }: { adjustment: string }) {
  switch (adjustment) {
    case '-1':
      return (
        <p>
          <strong>Fits large</strong>, we suggest buy -1 size smaller.
        </p>
      );
    case '-0.5':
      return (
        <p>
          <strong>Fits large</strong>, we suggest buy -0.5 size smaller.
        </p>
      );
    case '0':
      return <p>Fits true to size, buy your usual size.</p>;
    case '0.5':
      return (
        <p>
          <strong>Fits small</strong>, we suggest buy +0.5 size larger.
        </p>
      );
    case '1':
      return (
        <p>
          <strong>Fits small</strong>, we suggest buy +1 size larger.
        </p>
      );
    default:
      return <></>;
  }
}

export default SizeInfo;
